import React from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import moment from "moment";

import Button from '@mui/material/Button';
import leftarrow from "assets/images/arrow-right.png";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useState, useEffect, useContext } from "react";
import Context from "context/context";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { toast } from "react-toastify";
import FormControl from '@mui/material/FormControl';
import atcRosterAPI from "apis/panel/ATCRoster/atcRoster"
import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
import PoolPrepApis from "apis/panel/PoolPrepRoster/poolPrepRoster"
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Autocomplete from '@mui/material/Autocomplete';


const AddAtcRoster = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useContext(Context);
  const [region, setRegion] = useState("");
  const [practice, setPractice] = useState("");
  const [projectionDate, setProjectionDate] = useState(null);
  const [goLiveDate, setGoLiveDate] = useState(null);
 const [assignmentType, setAssignmentType] = useState("");
   const [atcSupport, setAtcSupport] = useState("");
 const [coverageStart, setCoverageStart] = useState(null);
const [coverageEnd, setCoverageEnd] = useState(null);
  const [shiftPattern, setShiftPattern] = useState("");
  const [handledByVra, setHandledByVra] = useState("");
  const [handledByRp, setHandledByRp] = useState("");
  const [remarks, setRemarks] = useState("");
  const [vraEmployees, setVraEmployees] = useState([])
  const [practices, setPractices] = useState([])
 

  const { getAllVraRosterAPI} = getAllVraShiftAPIS();
     const { getAllPracticesAPI } = PoolPrepApis();

  const handleGetAllVraEmployees = async () => {
    try {
      let res = await getAllVraRosterAPI();
      setVraEmployees(res?.data?.vraMaster || []);
    }
    catch (err) { }
  };

  const handleGetAllPractices = async () => {
    try {
      let res = await getAllPracticesAPI();
      setPractices(res?.data?.RpPractices || []);
    } catch (err) { }
  };

  useEffect(() => {
    handleGetAllVraEmployees()
    handleGetAllPractices()
  }, [])

  const maxDate = new Date()


  const [errorFields, setErrorFields] = useState({

    region: false,
    practice: false,
    projectionDate: false,
    goLiveDate: false,
    assignmentType: false,
    // atcSupport: false,
    coverageStart: false,
    coverageEnd: false,
    shiftPattern: false,
    handledByVra: false,
    handledByRp: false,

  });


  const { createAtcRosterAPI } = atcRosterAPI()


  const handleSaveAtcRoster = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!region) errors.region = true;
    if (!practice) errors.practice = true;
    // if (!projectionDate) errors.projectionDate = true;
    // if (!atcSupport) errors.atcSupport = true;
    if (!assignmentType) errors.assignmentType = true;
    if (!goLiveDate) errors.goLiveDate = true;
    if (!shiftPattern) errors.shiftPattern = true;
    if (!coverageStart) errors.coverageStart = true;
    if (!coverageEnd) errors.coverageEnd = true;
    if (!handledByVra) errors.handledByVra = true;
    if (!handledByRp) errors.handledByRp = true;

    setErrorFields(errors);

    if (Object.keys(errors).length === 0) {


      let values = {

        region: region,
        practice: practice,
        assignmentType: assignmentType,
        atcSupport: parseFloat(atcSupport),
        shiftPattern: shiftPattern,
        handledByVra: handledByVra,
        handledByRp: handledByRp,
        coverageStart: coverageStart.format("hh:mm A"),
        coverageEnd: coverageEnd.format("hh:mm A"),
        remarks: remarks,

      };

      if (moment(projectionDate).isValid()) {
        values = {
          ...values,
          projectionDate: moment(projectionDate).format("YYYY-MM-DD"),
        };
      }
      if (moment(goLiveDate).isValid()) {
        values = {
          ...values,
          goLiveDate: moment(goLiveDate).format(
            "YYYY-MM-DD"
          ),
        };
      }
     

      dispatch({ type: "SET_LOADING", payload: true });

      const res = await createAtcRosterAPI(values);


      if (res.status === 'Ok') {
        handleCancel()
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.success("Data Saved Successfully", { toast: "Data Saved Successfully" });
      }
      else {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Error: User already exists in the system");
      }

    }


  };

  const handleCancel = () => {
    handleReset()
    navigate("/panel/atcRoster")
  }

  const handleNavigation = () => {
    navigate("/panel/atcRoster")
  }

  const handleReset = () => {

    setRegion('')
    setPractice('')
    setAssignmentType('')
    setAtcSupport('')
    setShiftPattern('')
    setHandledByVra('')
    setHandledByRp('')
    setCoverageStart('')
    setCoverageEnd('')
    setRemarks('')
    setProjectionDate('')
    setGoLiveDate('')
   
  }

  const handleRegionChange = (event) => {
    const input = event.target.value;
    setRegion(input);
  };

  const handleGoLiveDateChange = (date) => {


    setGoLiveDate(date);

  };

  const handleAtcSupportChange = (event) => {
    const input = event.target.value;

    setAtcSupport(input);

  };

  const handleAssignmentTypeChange = (event) => {
    setAssignmentType(event.target.value);
  };

  const handleShiftPatternChange = (event) => {
    setShiftPattern(event.target.value);
  };

  const handleHandledByRpChange = (event) => {
    setHandledByRp(event.target.value);
  };

//   const handleCoverageStartChange = (event) => {
//     const input = event.target.value;
//     setCoverageStart(input);
//   };

//   const handleCoverageEndChange = (event) => {
//     const input = event.target.value;
//     setCoverageEnd(input);
//   };


  const handleProjectionDateChange = (date) => {

    setProjectionDate(date);
  };

  return (
    <div style={{ backgroundColor: "white", borderRadius: "5px", marginTop: "1%" }}>
      <Grid sx={{ pl: 1, pt: 2 }} >
        <div style={{ display: 'flex', alignItems: 'center', gap: "1%" }}>
          <div onClick={handleNavigation} style={{ cursor: 'pointer', alignItems: "center" }}>
            <img src={leftarrow} alt="Back" />
          </div>
          <div
            style={{
              fontFamily: "Inter",
              fontSize: '16px',
              fontWeight: '600',

              letterSpacing: '0.02em',
              textAlign: 'left',
              color: '#0070E9',
              alignItems: "center"
            }}
          >
            Add ATC Roster
          </div>

        </div>
      </Grid>

      <Grid container spacing={2} sx={{ pl: 4, pr: 5 }} >

        {/* Region */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Region <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="region"
              id="region"
              defaultValue=""
              displayEmpty
              name="region"
              value={region}
              onChange={handleRegionChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Region</MenuItem>
              <MenuItem value={"Matrix"}>Matrix</MenuItem>
              <MenuItem value={"Special Operations"}>Special Operations</MenuItem>
              <MenuItem value={"Apex"}>Apex</MenuItem>
              <MenuItem value={"Genesis"}>Genesis</MenuItem>
              <MenuItem value={"Maverick"}>Maverick</MenuItem>
              <MenuItem value={"Trailblazer"}>Trailblazer</MenuItem>
            </Select>
          </FormControl>
          {errorFields.region && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Practice */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label"> 
            {" "}
            Practice<span style={{ color: "red" }}>*</span></Box>
          <Autocomplete
            id="practice"
            options={practices}
            getOptionLabel={(option) => option.practiceName || ""}
            renderInput={(params) => <TextField {...params} placeholder="Select the Practice" fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.practiceName === value.practiceName
            }
            value={
              practices?.filter((p) => p.practiceName === practice)[0] ||
              {}
            }
            onChange={(event, newValue) => {
              setPractice(newValue ? newValue.practiceName : "");
            }}
          />
        {errorFields.practice && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

         {/* projection date  */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Projection Date </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="projectionDate"
              name="projectionDate"
              value={
                projectionDate ? new Date(projectionDate) : null
              }
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleProjectionDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
            />
          </LocalizationProvider>
          {/* {errorFields.projectionDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )} */}
        </Grid>

         {/* GoLive Date */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Go Live Date<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="goLiveDate"
              name="goLiveDate"
              value={goLiveDate ? new Date(goLiveDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleGoLiveDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
             
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
          {errorFields.goLiveDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Assignment Type */}
          <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Assignment Type <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="assignmentType"
            value={assignmentType}
            onChange={handleAssignmentTypeChange}
            placeholder="Enter Assignment Type"
            variant="outlined"
            fullWidth
          />
          {errorFields.assignmentType && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* atc support */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            No of ATC Support 
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="atcSupport"
            value={atcSupport}
            onChange={handleAtcSupportChange}
            placeholder="Enter No of ATC Support"
            variant="outlined"
            fullWidth
            type="number" 
          />
         
        </Grid>

        {/* coverage start time */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 1 }}>
          <Box className="label">
            {" "}
            Coverage Duration Start Time<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={["TimePicker"]}
              style={{ overflowY: "scroll" }}
            >
              <TimePicker
                label=""
                value={coverageStart}
                sx={{ width: "100%" }}
                onChange={(newValue) => {
                  setCoverageStart(newValue);
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorFields.coverageStart && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* coverage end time    */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Coverage Duration End Time<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={["TimePicker"]}
              style={{ overflowY: "scroll" }}
            >
              <TimePicker
                label=""
                value={coverageEnd}
                sx={{ width: "100%" }}
                onChange={(newValue) => {
                  setCoverageEnd(newValue);
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
         {errorFields.coverageEnd && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>
    
        {/* shift pattern */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Shift Pattern <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="shiftPattern"
            value={shiftPattern}
            onChange={handleShiftPatternChange}
            placeholder="Enter Shift Pattern"
            variant="outlined"
            fullWidth
          />
          {errorFields.shiftPattern && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        
        {/* handled by Vra */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label"> 
            {" "}
            Handled By VH<span style={{ color: "red" }}>*</span></Box>
          <Autocomplete
            id="handled-by-vra"
            options={vraEmployees}
            getOptionLabel={(option) => option.vraFullname || ""}
            renderInput={(params) => <TextField {...params} placeholder="Select handled by VH" fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.vraRosterId === value.vraRosterId
            }
            value={
              vraEmployees?.filter((v) => v.vraRosterId === handledByVra)[0] ||
              {}
            }
            onChange={(event, newValue) => {
              setHandledByVra(newValue ? newValue.vraRosterId : "");
            }}
          />
          {errorFields.handledByVra && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* handled by RP */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Handled By RP<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="handledByRp"
            value={handledByRp}
            onChange={handleHandledByRpChange}
            placeholder="Enter handled by RP"
            variant="outlined"
            fullWidth
          />
          {errorFields.handledByRp && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        

        {/* Remarks */}
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Remarks</Box>

          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="remarks"
            name="remarks"
            placeholder="Enter remarks"
            variant="outlined"
            fullWidth
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value.trimStart())}
            onBlur={(e) => setRemarks(e.target.value.trim())} />


        </Grid>

      </Grid>


      <Grid container sx={{ pl: 4, pr: 5, mt: 5, mb: 5, pb: 4, justifyContent: "center" }} >
        <Grid item sx={{ ml: 1 }} xs={12} sm={3} md={3} lg={3}>
          <Button className="resetChanges" onClick={handleReset}>Reset Changes</Button>
        </Grid>

        <Grid item xs={12} sm={2} md={2} lg={2}>
          <Button className="cancelButton" onClick={handleCancel}>Cancel</Button>
        </Grid>

        <Grid item sx={{ mr: 1 }} xs={12} sm={2} md={2} lg={2}>
          <Button className="saveButton" onClick={handleSaveAtcRoster} >Save</Button>
        </Grid>

      </Grid>

    </div>
  )
}

export default AddAtcRoster;
